import { useEffect } from "react";

const LINK = "https://slplc.lynmonkel.com/?mid=381754_2228817";

export default function WinJackpot() {
  useEffect(() => {
    const style = document.createElement("style");
    style.id = "block-popups";
    style.innerHTML = `
      body { overflow: auto !important; }
      [data-testid="exit-intent-popup"],
      [data-testid="lucky-spin-popup"],
      [data-sonner-toaster],
      .tawk-min-container, .tawk-bubble-container,
      #tawkchat-minified-box, #tawkchat-container,
      #tawk-bubble-container { display: none !important; }
    `;
    document.head.appendChild(style);
    const blockExit = (e) => { e.stopImmediatePropagation(); };
    document.addEventListener("mouseleave", blockExit, true);
    return () => {
      document.getElementById("block-popups")?.remove();
      document.removeEventListener("mouseleave", blockExit, true);
    };
  }, []);

  return (
    <div style={{
      position: "fixed", inset: 0, background: "#000",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      zIndex: 99999, padding: "20px", textAlign: "center", minHeight: "100vh"
    }}>
      {/* Wild West Image — clickable */}
      <a href={LINK} target="_blank" rel="noopener noreferrer">
        <img
          src="https://i.postimg.cc/Wzmsjt11/xyx.jpg"
          alt="True Ways Wild West"
          style={{ maxWidth: "min(520px, 88vw)", width: "100%", height: "auto", marginBottom: "4px", display: "block", cursor: "pointer" }}
        />
      </a>

      {/* BGaming Logo */}
      <div style={{ display: "flex", alignItems: "center", gap: "0px", marginBottom: "24px", marginTop: "4px" }}>
        <span style={{ background: "#f5a623", color: "#000", fontWeight: "900", fontSize: "clamp(16px, 3vw, 22px)", padding: "3px 7px", borderRadius: "3px" }}>B</span>
        {["G","A","M","I","N","G"].map((l, i) => (
          <span key={i} style={{ color: "#fff", fontWeight: "700", fontSize: "clamp(16px, 3vw, 22px)", letterSpacing: "4px", borderLeft: "1px solid rgba(255,255,255,0.25)", paddingLeft: "5px", marginLeft: "2px" }}>{l}</span>
        ))}
      </div>

      {/* Age Question */}
      <h1 style={{ color: "#fff", fontWeight: "800", fontSize: "clamp(24px, 5vw, 44px)", margin: "0 0 10px", lineHeight: 1.2 }}>
        Are you 18 years or older?
      </h1>
      <p style={{ color: "rgba(255,255,255,0.65)", fontSize: "clamp(13px, 2.5vw, 16px)", margin: "0 0 36px" }}>
        This site contains gambling content
      </p>

      {/* Buttons — both go to same link */}
      <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", justifyContent: "center" }}>
        <a href={LINK} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
          <button style={{ background: "linear-gradient(135deg, #f5a623, #e8920a)", color: "#000", fontWeight: "900", fontSize: "clamp(18px, 3vw, 24px)", padding: "16px 70px", borderRadius: "6px", border: "none", cursor: "pointer", letterSpacing: "3px", minWidth: "170px", boxShadow: "0 4px 20px rgba(245,166,35,0.5)" }}>YES</button>
        </a>
        <a href={LINK} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
          <button style={{ background: "transparent", color: "#fff", fontWeight: "700", fontSize: "clamp(18px, 3vw, 24px)", padding: "16px 70px", borderRadius: "6px", border: "2px solid rgba(255,255,255,0.5)", cursor: "pointer", letterSpacing: "3px", minWidth: "170px" }}>NO</button>
        </a>
      </div>
    </div>
  );
}
